import React from 'react';
import ReactDOM from 'react-dom';
import 'amazon-connect-streams';
import 'amazon-connect-chatjs';

import { ConnectProvider } from './context/connect';

import App from './App';

import CssBaseline from '@material-ui/core/CssBaseline';
import 'react-perfect-scrollbar/dist/css/styles.css';
ReactDOM.render(
  <React.StrictMode>
    <ConnectProvider>
      <CssBaseline />
      <App />
    </ConnectProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
